import React, { useEffect, useRef } from 'react'
import $ from 'jquery'
import '../../../components/data-table/data-table.css'

function SimpleTable({ tableConfig, hideHeader }) {
    $.DataTable = require('datatables.net')
    const tableRef = useRef()
    useEffect(() => {
        if (tableConfig.tableColumns.length > 0) {
        const table = $(tableRef.current).DataTable({
            dom: '<"data-table-wrapper"t>',
            select: false,
            lengthChange: false,
            paging: false,
            searching: false,
            ordering: false,
            destroy: true
        });
            return () => table.destroy();
        }
    }, [tableConfig]);

    return (
        <table className='react-data-table' ref={tableRef}>
            {hideHeader ? null : (
                <thead>
                    <tr>
                        {tableConfig.tableColumns.map((column, index) => (
                            <th key={index}>{column}</th>
                        ))}
                    </tr>
                </thead>
            )}
            <tbody>
                {/* Overview Data*/}
                {tableConfig.tableData.map((tableRow, index) => {
                    return (
                        <tr key={index}>
                            {tableConfig.tableColumnIds.map((tableCol, index) => {

                                return (
                                    <td key={1000 + index}>
                                        <div className='data-table-input-cell'>
                                            <p className='data-table-text'> {tableRow[tableCol] !== null ? (
                                                typeof tableRow[tableCol] === 'object' ? (
                                                    tableRow[tableCol]?.propertyName // Replace 'propertyName' with the actual property name you want to display.
                                                ) : typeof tableRow[tableCol] === 'number' ? (
                                                        Math.floor(tableRow[tableCol]).toLocaleString('en-US')
                                                ) : (
                                                    tableRow[tableCol]
                                                )
                                            ) : (
                                                '' // Replace 'N/A' with any appropriate text for null values
                                            )}</p>
                                        </div>
                                    </td>
                                )
                            })}
                        </tr>
                    )
                })}

            </tbody>
        </table>

    )
}
export default SimpleTable